// extracted by css-extract-rspack-plugin
export default {"root":"UZYdN","icon":"NmvuX"};